module.exports = __webpack_public_path__ + "6c7f20b675f0fa8025dc0f84f5e21dfb.svg";